export default "__VITE_ASSET__aKKmLpvI__"